<div class="table-container" [class.warm]="variant() === 'warm'">
  <table>
    <thead>
      <tr>
        @for (col of columns(); track col.key) {
          <th [class.mono]="col.mono" [style.text-align]="col.align || 'left'">
            {{ col.label }}
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of data(); track $index) {
        <tr>
          @for (col of columns(); track col.key) {
            <td
              [class.mono]="col.mono"
              [style.text-align]="col.align || 'left'"
              [style.color]="row[col.key + 'Color'] || null"
              [style.font-weight]="row[col.key + 'Bold'] ? 700 : null"
            >
              {{ row[col.key] }}
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
